const fi = {
  nav: {
    logo: 'Tapio Tulenheimo',
    contact: 'Ota yhteyttä',
  },
  hero: {
    line1: 'Psykologi. Liikuntafysiologi.',
    line2: 'Yrittäjä.',
  },
  profile: {
    title: 'Ajattele kuin tieteilijä. Toimi kuin yrittäjä.',
    para1:
      'Tiede tuottaa jatkuvasti uusia oivalluksia ihmisen suorituskyvystä, päätöksenteosta ja hyvinvoinnista. Harvalla on kuitenkaan kyky soveltaa tätä tietoa arjen valintoihin ja pyrkiä päivittäin kohti korkeampaa elämänlaatua.',
    para2:
      'Olen psykologi, liikuntafysiologi ja yrittäjä. Autan yrittäjiä, johtohenkilöstöä ja tiimejä kehittämään resilienssiä, päätöksentekoa ja kestävää suorituskykyä. Työssäni yhdistyvät startup-maailman muovaama ajattelu sekä psykologian ja liikuntafysiologian tieteellinen näkökulma.',
    para3: '',
    readMore: 'Lue lisää',
    credentials: 'Tapio Tulenheimo\nPsykologi · Liikuntafysiologi · Yrittäjä',
    coaching: 'Valmennus',
    speaking: 'Puhujaksi',
  },
  media: {
    label: 'Julkinen työ',
  },
  contact: {
    heading: 'Ota yhteyttä',
    linkedIn: 'LinkedIn',
  },
  footer: {
    copyright: '© {year} Tapio Tulenheimo',
  },
  popup: {
    close: 'Sulje',
    coaching: {
      title: 'Valmennus',
      para1:
        'Psykologista valmennusta yrittäjille, johtavissa positioissa toimiville sekä tiimeille. Tarkoituksena kehittää niin psykologisesti kuin fysiologisesti paras versio itsestä, jotta voidaan saavuttaa korkeimmat tavoitteet elämässä.\n\nValmennus hyödyntää syvällisellä tasolla psykologista ja liikuntatieteellistä tutkimusnäyttöä sekä yritysmaailman muovaamaa nopeaa päätöksentekoa kohti tuloksia.',
      para2:
        'Jos olet kiinnostunut valmennuksesta, laita sähköpostia alla näkyvään osoitteeseen. Tämän jälkeen sovittaisiin lyhyt kartoituspuhelu, jossa kävisimme läpi yhteistyön mahdollisuuksia. Puhelu ei ole maksullinen, eikä sido mihinkään.',
    },
    speaking: {
      title: 'Puhujaksi',
      para1:
        'Esiintymisiä, jotka yhdistävät yritysmaailman ajattelun sekä psykologian ja liikuntafysiologian tutkimusnäytön käytännön sovellutukset.\n\nTavoitteena inspiroida ja antaa konkreettisia työkaluja kehittämään ajattelua, päätöksentekoa ja omaa resilienssiä.',
      para2:
        'Esiintymiset suunnitellaan organisaatioille, johtoryhmille ja tapahtumiin aina toiveiden mukaisesti. Lisätiedot ja varaukset hoituvat nopeasti sähköpostitse.',
    },
    about: {
      title: 'Minusta',
      para1:
        'Koulutukseltani olen psykologi (Helsingin yliopisto) ja liikuntafysiologi (Jyväskylän yliopisto). Yrittäjänä toimin tällä hetkellä teknologiayrityksessämme AITOFIT. Yrittäjän polkuun on mahtunut lisäksi laaja kirjo asiantuntijuutta aina psykologin vastaanotosta liikunta-alan ammattilaisten kouluttamiseen.',
      para2:
        'Intohimoni on ihmisen fysiologisen ja psykologisen kyvykkyyden ymmärtäminen ja kuinka hyödyntää arjessa psykologista sekä fysiologista tutkimusnäyttöä.',
      para3:
        'Startup-maailma on opettanut vähintään yhtä paljon kuin akateeminen yhteisö. Menestyminen vaatii jatkuvaa itsensä ylittämistä ja tiimityöskentely pitää olla äärimmäisen innovatiivista ja saumatonta.',
      para4:
        'Valmennuksessani ja puheissani yhdistyvät tutkimusnäyttöön perustuva psykologinen ja liikuntatieteellinen ymmärrys sekä käytännön kokemus yritysmaailmasta. Tavoitteena on auttaa ihmisiä ja tiimejä tekemään parempia päätöksiä, vahvistamaan resilienssiä ja rakentamaan kestävää suorituskykyä ilman, että hyvinvointi jää sivuun.',
      para5: '',
    },
    media: {
      title: 'Julkinen työ',
      intro1:
        'Yhteenveto julkisesta työstäni median, podcastien ja yritystoiminnan parissa.',
      intro2:
        'Suurin osa näistä on tehty yhdessä pitkäaikaisen yhtiökumppanini Julius Granlundin kanssa (yrityksemme AITOFIT, podcastimme Psykalab sekä suurin osa artikkeleista yhteisestä työstämme).',
      companyLabel: 'Yrityksemme: AITOFIT',
      companyUrl: 'https://www.aitofit.io/',
      links: [
        { name: 'Podcastimme: Psykalab', url: 'https://open.spotify.com/show/3UtitB2xAeMKCilwjKCoba?si=1c66001ce37a4d53' },
        { name: 'Talouselämä: Yrityksen perustaneet Julius Granlund ja Tapio Tulenheimo myivät autonsa ja vetivät tilinsä rumasti miinukselle – sitten tuli huima kasvu', url: 'https://www.talouselama.fi/uutiset/a/6185f925-25e5-4e96-a06a-5715efa299c6' },
        { name: 'Helsingin Sanomat: Jyväskylän maisterit maailmanvalloitukseen', url: 'https://www.hs.fi/urheilu/art-2000010018747.html' },
        { name: 'Helsingin Sanomat: Valmentaja puhelimessa', url: 'https://www.hs.fi/hyvinvointi/art-2000010292988.html' },
        { name: 'Keski-Suomalainen: Kahden jyväskyläläisen liikuntabiologin opit saliharjoittelusta jalostuivat innovaatioksi', url: 'https://www.ksml.fi/paikalliset/5988861' },
        { name: 'JYU: Alumniesittelyssä Julius Granlund ja Tapio Tulenheimo', url: 'https://www.jyu.fi/fi/tarina/alumniesittelyssa-julius-granlund-ja-tapio-tulenheimo' },
        { name: 'MTV: Miksi lihaksiin koskee treenin jälkeen? Ei kerro palautumisesta mitään', url: 'https://www.mtvuutiset.fi/artikkeli/miksi-lihaksiin-koskee-treenin-jalkeen-ei-kerro-palautumisesta-mitaan/8862828' },
        { name: 'MTV: Yllättävä jippo voi mullistaa penkkipunnerruksesi?', url: 'https://www.mtvuutiset.fi/artikkeli/yllattava-jippo-voi-mullistaa-penkkipunnerruksesi-kehonrakennuksen-kummiseta-saa-vastauksen-suomesta/9273804' },
        { name: 'Lihastohtori-blogi: Penkkipunnerrus – osa I', url: 'https://lihastohtori.wordpress.com/2020/01/25/penkkipunnerrus1/' },
        { name: 'Lihastohtori-blogi: Penkkipunnerrus – Osa II', url: 'https://lihastohtori.wordpress.com/2020/03/04/penkki_tekniikka/' },
        { name: 'Lihastohtori-blogi: Uskomusten voima', url: 'https://lihastohtori.wordpress.com/2023/11/02/uskomusten-voima-plasebo-ja-nosebovaikutukset/' },
        { name: 'Anna-Lehti: Näin kävi, kun tekoäly laati salitreeniohjelman', url: 'https://anna.fi/hyvinvointi/liikunta/aitofit-kokemuksia' },
      ],
    },
  },
  seo: {
    title: 'Tapio Tulenheimo – Psykologi ja liikuntafysiologi',
    description:
      'Psykologi, liikuntafysiologi ja yrittäjä. Luentoja, valmennusta ja esiintymisiä siitä, kuinka yhdistää psykologinen ja fysiologinen tutkimusnäyttö arjen työkaluiksi ja saavuttaa kunnianhimoisia tavoitteita.',
    ogTitle: 'Tapio Tulenheimo – Psykologi ja liikuntafysiologi',
    ogDescription:
      'Psykologi, liikuntafysiologi ja yrittäjä. Luentoja, valmennusta ja esiintymisiä siitä, kuinka yhdistää psykologinen ja fysiologinen tutkimusnäyttö arjen työkaluiksi ja saavuttaa kunnianhimoisia tavoitteita.',
  },
};

export default fi;
